import { SurveyPostAnswerMetaSvend } from '@surveycake/logic-engine';
import { useSurveyConfig } from 'app/core/survey-config';
import {
  Banner,
  Container,
  Footer,
  Header,
  Intro,
  SlateHtml
} from 'app/shared/components';
import { useRemoveLoading } from 'app/shared/utils/removeLoading';
import React, { FC } from 'react';
import { config } from './config';
import Redirect from './Redirect';

export interface EndingProps {
  type: SurveyPostAnswerMetaSvend;
}

const Ending: FC<EndingProps> = ({ type }) => {
  const surveyConfig = useSurveyConfig();
  const { banner, text } = config[type](surveyConfig);

  useRemoveLoading();

  if (!(type in config)) {
    return null;
  }

  return (
    <div>
      <Container>
        <Header
          banner={<Banner banner={banner} />}
          intro={
            <Intro>
              <SlateHtml html={text} />
            </Intro>
          }
        >
          <Redirect type={type} />
        </Header>
      </Container>
      <Footer />
    </div>
  );
};

export default Ending;

export { config };
